import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAxios from './plugins/VueAxios.js';
import ShopifyAppBridge from './plugins/ShopifyAppBridge.js';

import {
    BootstrapVue,
    BootstrapVueIcons
} from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

window.bus = new Vue();

Vue.use(ShopifyAppBridge);
Vue.use(VueAxios);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
